module.exports = __webpack_public_path__ + "img/zhineng.a740394d.jpg";